module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('title', [_vm._v("With My Little Eye")]), _vm._v(" "), _c('link', {
    attrs: {
      "href": "../styles/styles.css",
      "rel": "stylesheet",
      "type": "text/css"
    }
  }), _vm._v(" "), _c('h3', {
    staticClass: "books-by-head1"
  }, [_c('em', [_vm._v("Recent Titles by Gerald Hammond from Severn House")])]), _vm._v(" "), _c('p', {
    staticClass: "books-by-text"
  }, [_vm._v("COLD IN THE HEADS")]), _vm._v(" "), _c('p', {
    staticClass: "books-by-text"
  }, [_vm._v("CRASH")]), _vm._v(" "), _c('p', {
    staticClass: "books-by-text"
  }, [_vm._v("DOWN THE GARDEN PATH")]), _vm._v(" "), _c('p', {
    staticClass: "books-by-text"
  }, [_vm._v("THE DIRTY DOLLAR")]), _vm._v(" "), _c('p', {
    staticClass: "books-by-text"
  }, [_vm._v("A DOG’S LIFE")]), _vm._v(" "), _c('p', {
    staticClass: "books-by-text"
  }, [_vm._v("FINE TUNE")]), _vm._v(" "), _c('p', {
    staticClass: "books-by-text"
  }, [_vm._v("THE FINGERS OF ONE FOOT")]), _vm._v(" "), _c('p', {
    staticClass: "books-by-text"
  }, [_vm._v("FLAMESCAPE")]), _vm._v(" "), _c('p', {
    staticClass: "books-by-text"
  }, [_vm._v("GRAIL FOR SALE")]), _vm._v(" "), _c('p', {
    staticClass: "books-by-text"
  }, [_vm._v("HIT AND RUN")]), _vm._v(" "), _c('p', {
    staticClass: "books-by-text"
  }, [_vm._v("THE HITCH")]), _vm._v(" "), _c('p', {
    staticClass: "books-by-text"
  }, [_vm._v("INTO THE BLUE")]), _vm._v(" "), _c('p', {
    staticClass: "books-by-text"
  }, [_vm._v("KEEPER TURNED POACHER")]), _vm._v(" "), _c('p', {
    staticClass: "books-by-text"
  }, [_vm._v("LOVING MEMORY")]), _vm._v(" "), _c('p', {
    staticClass: "books-by-text"
  }, [_vm._v("ON THE WARPATH")]), _vm._v(" "), _c('p', {
    staticClass: "books-by-text"
  }, [_vm._v("THE OUTPOST")]), _vm._v(" "), _c('p', {
    staticClass: "books-by-text"
  }, [_vm._v("A RUNNING JUMP")]), _vm._v(" "), _c('p', {
    staticClass: "books-by-text"
  }, [_vm._v("SILENT INTRUDER")]), _vm._v(" "), _c('p', {
    staticClass: "books-by-text"
  }, [_vm._v("THE SNATCH")]), _vm._v(" "), _c('p', {
    staticClass: "books-by-text"
  }, [_vm._v("WAKING PARTNERS")]), _vm._v(" "), _c('p', {
    staticClass: "books-by-text"
  }, [_vm._v("WELL AND GOOD")]), _vm._v(" "), _c('p', {
    staticClass: "books-by-text"
  }, [_vm._v("WITH MY LITTLE EYE")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-11794cbc","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/alsoby.vue
// module id = 63
// module chunks = 0